module.exports = __webpack_public_path__ + "img/booking.01da844d.jpg";